import { Injectable } from '@angular/core';
import {
	HttpErrorResponse,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { BehaviorSubject, from, Observable, of, throwError, zip } from 'rxjs';
import {
	catchError,
	filter,
	retry,
	switchMap,
	take,
	timeout
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../auth/auth.service';
import { AlertService } from '@v-locker-app/v-locker-common';
import { AuthenticationApiService } from 'src/app/api/services';
import { ApiConfiguration } from 'src/app/msp-api/api-configuration';
import { NetworkState, StorageEnums } from 'src/shared/models/enums';
import { CustomToastService } from 'src/shared/services/custom-toast.service';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { HelperService } from 'src/shared/services/helpers/helper.service';
import { ModalController } from '@ionic/angular/standalone';

@Injectable({
	providedIn: 'root'
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
	private isRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

	constructor(
		private router: Router,
		private AuthenticationApiService: AuthenticationApiService,
		private spinner: CustomSpinnerService,
		private storage: StorageService,
		public authService: AuthService,
		private alertService: AlertService,
		private customToastService: CustomToastService,
		private modalController: ModalController,
		private helperService: HelperService,
		private apiConfiguration: ApiConfiguration) {
	}

	intercept(request: any, next: HttpHandler): Observable<any> {
		return next.handle(request)
			.pipe(
				// retry(1),
				catchError((err: HttpErrorResponse) => {
					console.log('catchError', err);
					let customError = err.error ? err.error : {
						status: err.status,
						message: err.message ? err.message : ''
					};


					if (err.message !== 'Network is not available' && err.statusText !== 'Unknown Error'
						&& err.status !== 401 && err.status !== 403) {
						// this.logsService.log(err.message, err, 'error')
					}

					if ((err.status === 401 || err.status === 403)
						&& !request.url.includes('/auth')
						&& !request.url.includes('/api/v1/')
						&& !request.url.includes('/oauth/v2/token')
					) {
						console.log(`err ${ err.status }:`, this.apiConfiguration.rootUrl, request.url);
						return this.handle401Error(request, next);
					} else if (err.message === 'Network is not available') {
						console.log('err on:', err.status, err);
					}

					if (err instanceof ErrorEvent) {
						// client-side error
						// customError = `Error: ${ err.message }`;
					}

					if (err.error && err.error.error) {
						// server-side error
						// customError = err.error.error.details || err.error.error.message.replace(/[\[\]']+/g, '');
					}

					if (err.statusText === 'Unknown Error') {
						customError.message = window.navigator.onLine ? err.statusText : 'Network is not available';
						this.customToastService.danger(this.customToastService.getMessage(NetworkState.Disconnected), null);
						this.spinner.hide();
					}

					if ((err.status === 500 || err.status === 400)) {
						this.spinner.hide();
						if (err.status === 500 && !request.url.includes('/auth')) {
							this.alertService.somethingWentWrong();
						} else if ((err.status === 500 || err.status === 400) && request.url.includes('/auth')) {
							this.helperService.logout(false, true);
						}
					}

					if (customError instanceof Object) {
					} else {
						customError = JSON.parse(customError);
					}
					return throwError(customError);
				})
			);
	}


	private applyCredentials(request: HttpRequest<any>, token: string) {
		return request.clone({
			headers: request.headers.set('Authorization', 'Bearer ' + token)
		});
	}

	private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
		if (!this.isRefreshing) {
			this.isRefreshing = true;
			this.refreshTokenSubject.next(null);
			// return of('').pipe(
			//   tap(() => {
			//     this.spinner.hide();
			//     this.router.navigate(['/auth']);
			//   })
			// );
			return of('').pipe(
				switchMap(() => {
					return from(Promise.all([
						this.storage.getItem(StorageEnums.REFRESH_TOKEN)
					]));
				}),
				switchMap(([refresh]) => {
					if(refresh) {
						return this.AuthenticationApiService.refreshToken().pipe(
							// timeout(500),
							switchMap((token: any) => {
								return from(Promise.all([
									this.storage.setItem(StorageEnums.REFRESH_TOKEN, token.refreshToken),
									this.storage.setItem(StorageEnums.AUTH_TOKEN, token.accessToken)
								]));
							}),
							switchMap(([refresh, access]) => {
								this.refreshTokenSubject.next(access);
								this.isRefreshing = false;
								return next.handle(this.applyCredentials(request, access));
							}),
							catchError(async (err) => {
								console.log('refreshToken error', err);
								if (err.status === 500 || err.status === 403 || err.status === 401) {
									this.logout();
								}
								return throwError(() => err);
							})
						);
					}
					else {
						this.isRefreshing = false;
						this.logout();
					}
				})
			);
		} else {
			if(!request.url.includes('refresh')) {
				return this.refreshTokenSubject.pipe(
					filter(token => token != null),
					take(1),
					switchMap(jwt => {
						return next.handle(this.applyCredentials(request, jwt));
				}));
			}
			else {
				this.logout();
				return throwError(() => {});
			}
		}
	}

	private logout() {
		this.authService.updateAuth(false);
		try {
			this.modalController.dismiss();
			this.spinner.hide();
		} catch (error) {
		}
		this.storage.clearOnLogout();
		setTimeout(() => {
			this.router.navigate(['/auth']);
		}, 100);
		this.isRefreshing = false;
	}
}
